// LanguageSwitcher.jsx
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

import USFlag from '../../assets/languages/icons/US.svg';
import BGFlag from '../../assets/languages/icons/BG.svg';
import DEFlag from '../../assets/languages/icons/DE.svg';
import RSFlag from '../../assets/languages/icons/RS.svg';
import RUFlag from '../../assets/languages/icons/RU.svg';

const LANGUAGES = [
  { code: 'en', label: 'English', icon: USFlag },
  { code: 'bg', label: 'Български', icon: BGFlag },
  { code: 'de', label: 'Deutsch', icon: DEFlag },
  { code: 'sr', label: 'Српски', icon: RSFlag },
  { code: 'ru', label: 'Русский', icon: RUFlag },
];

export default function LanguageSwitcher({ onChange }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChanged = () => {
      console.log('Language changed to:', i18n.language);
      setCurrentLang(i18n.language);
      onChange?.();
    };

    i18n.on('languageChanged', handleLanguageChanged);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n, onChange]);

  const currentLangData = LANGUAGES.find((l) => l.code === currentLang) || LANGUAGES[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('i18nextLng', code);
    localStorage.setItem('language', code);
    setOpen(false);
  };

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={styles.wrapper} ref={ref}>
      <button
        className={styles.trigger}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <img
          src={currentLangData.icon}
          alt={currentLangData.label}
          className={styles.flag}
        />
        <span className={styles.label}>{currentLangData.label}</span>
      </button>

      {open && (
        <ul className={styles.dropdown} role="listbox">
          {LANGUAGES.map((lang) => (
            <li key={lang.code}>
              <button
                className={`${styles.option} ${
                  lang.code === currentLang ? styles.active : ''
                }`}
                onClick={() => changeLanguage(lang.code)}
              >
                <img
                  src={lang.icon}
                  alt={lang.label}
                  className={styles.flag}
                />
                <span>{lang.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}